// src/App.js
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Login from "./components/Login";
import Callback from "./components/Callback";
import OrgInstallWrapper from "./components/OrgInstallWrapper";
import DevStreamPopout from "./pages/DevStreamPopout";
import Welcome from "./pages/Welcome";
import Support from "./pages/Support";
import "./App.css";

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/welcome" element={<Welcome />} />
        <Route path="/support" element={<Support />} />
        <Route path="/login" element={<Login />} />
        <Route path="/callback" element={<Callback />} />
        <Route
          path="/devstream-popout"
          element={
            <ProtectedRoute>
              <DevStreamPopout />
            </ProtectedRoute>
          }
        />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <OrgInstallWrapper />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;
